import { MemCommonMentionKind } from "@mem-labs/common-editor";

// Slot names for customization
export enum MDSComboboxSlotName {
  LeftAddon = "left",
  RightAddon = "right",
  ActionButton = "action",
}

// Item interface
export interface MDSComboboxItem {
  id: string;
  label: string;
  value?: string;
  disabled?: boolean;
  kind: MemCommonMentionKind;
  metadata?: Record<string, unknown>;
}

export enum MDSComboboxColor {
  Blue = "blue",
  Error = "error",
  Default = "default",
}

// State interface for the combobox reducer
export interface ComboboxState<T> {
  isOpen: boolean;
  query: string;
  isEmpty: boolean;
  isLoading: boolean;
  data: T[];
  hasSearched: boolean;
}

// Action types for the combobox reducer
export type ComboboxAction<T> =
  | { type: "QUERY_CHANGED"; payload: string }
  | { type: "SEARCH_STARTED" }
  | { type: "SEARCH_COMPLETED"; payload: T[] }
  | { type: "SEARCH_FAILED" }
  | { type: "LOADING_STARTED" }
  | { type: "LOADING_STOPPED" }
  | { type: "POPOVER_OPENED" }
  | { type: "POPOVER_CLOSED" }
  | { type: "EMPTY_STATE_CHANGED"; payload: boolean }
  | { type: "RESET" };

export type MDSComboboxMention = {
  kind: MemCommonMentionKind;
} & (
  | {
      kind: MemCommonMentionKind.Collection;
      collection_id: string;
      collection_title: string;
    }
  | {
      kind: MemCommonMentionKind.Note;
      note_id: string;
      note_primary_label: string;
    }
);
